export default "__VITE_ASSET__CHmY51si__"